export default "/shBKB.c777f8df96d56e924f81132e56729fff.png";